module.exports = __webpack_public_path__ + "img/34-l.a6d58976.png";